document.addEventListener("DOMContentLoaded", () => {
    if (!customElements.get("hot-spots")) {
        class HotSpotElement extends HTMLElement {
            buttonEvents = ['click', 'touchstart', 'keydown'];

            constructor() {
                super();
                this.hotSpotDots = [];
                this.hotSpotDetails = [];
            }

            connectedCallback() {
                this.init();
            }

            init() {
                this.hotSpotDots = this.querySelectorAll('.hot-spot__dot');
                this.hotSpotDetails = this.querySelectorAll('.hot-spot-product-block');

                this.setupEventListeners();
                this.activateHotSpot(0);
            }

            setupEventListeners() {
                this.hotSpotDots.forEach(hotSpot => {
                    this.buttonEvents.forEach(event => {
                        hotSpot.addEventListener(event, (e) => this.handleHotSpotInteraction(e, hotSpot, event));
                    });
                });
            }

            handleHotSpotInteraction(e, hotSpot, event) {
                if (event === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
                    return;
                }
                e.preventDefault();
                e.stopPropagation();

                const spotControls = hotSpot.getAttribute('aria-controls');
                const spotDetails = document.getElementById(spotControls);
                const isExpanded = hotSpot.getAttribute('aria-expanded') === 'true';
                if (isExpanded || !spotDetails) {
                    return;
                }
                this.deactivateDots();
                this.activateCurrentDot(hotSpot);
                this.deactivateDetails();
                this.activateCurrentDetails(spotDetails);
            }

            deactivateDots() {
                this.hotSpotDots.forEach(dot => {
                    dot.setAttribute('aria-expanded', 'false');
                    dot.removeAttribute('disabled');
                    dot.classList.remove('active');
                });
            }

            activateCurrentDot(hotSpot) {
                hotSpot.setAttribute('aria-expanded', 'true');
                hotSpot.setAttribute('disabled', 'true');
                hotSpot.classList.add('active');
            }

            deactivateDetails() {
                this.hotSpotDetails.forEach(spotDetails => {
                    spotDetails.setAttribute('aria-hidden', 'true');
                    spotDetails.classList.remove('active');
                });
            }

            activateCurrentDetails(spotDetails) {
                spotDetails.setAttribute('aria-hidden', 'false');
                spotDetails.classList.add('active');
            }

            resetAllHotSpots() {
                this.hotSpotDots.forEach(dot => {
                    dot.setAttribute('aria-expanded', 'false');
                    dot.classList.remove('active');
                });

                this.hotSpotDetails.forEach(detail => {
                    detail.setAttribute('aria-hidden', 'true');
                    detail.classList.remove('active');
                });
            }

            activateHotSpot(index) {
                if (this.hotSpotDots[index]) {
                    this.hotSpotDots[index].click();
                }
            }
        }

        customElements.define('hot-spots', HotSpotElement);
    }
});
